import StockTransferNotesContainer from '@components/containers/warehouseOps/stn';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const StockTransfers: FC = () => (
    <AppLayout>
        <StockTransferNotesContainer />
    </AppLayout>
);

export default StockTransfers;
